<template>
  <section class="filters-board full-vh slide-right" ref="filtersPan">
    <header class="board-header">
      <p class="header-components v-align-between">
        <span>{{ $t('_filter.filtering') }}</span>
        <span @click="slidePan"><i class="fas fa-times"></i></span>
      </p>

      <hr>

      <p class="v-align-between">
        <b-button class="btn orange-white btn-validate" @click="$emit('submit')">
          {{ $t('_validate') }}
        </b-button>

        <b-button class="btn-as-link" @click="$emit('reset-all')">
          {{ $t('_reset_all') }}
        </b-button>
      </p>
    </header>

    <div>
      <div class="filters-card">
        <div v-for="(filter, type, index) in filters" :key="type">
          <div class="card-header v-align-between" v-b-toggle="type">
            <span class="icon-inner title">
              {{ $t(`online.filters.${type}.title`) }}
            </span>

            <fa :fa-class="collapseChevronClass(filter.visible)" v-if="!filter.noCollapse" />

            <component v-else :is="type" :name="type" :ref="type" v-bind="filter.props"
                       @update="update($event)" :initSelected="initFilters ? initFilters[type] : null"
            />
          </div>

          <b-collapse v-if="!filter.noCollapse" :id="type" class="card-body" role="tabpanel" accordion="filters"
                      :visible="!index" @input="toggleOpenedComponent(type, $event)"
          >
            <component :is="type" :name="type" :ref="type" v-bind="filter.props"
                       @update="update($event)"
                       :initSelected="initFilters ? initFilters[type] : null"
                       :orig-min="origMinPrice" :orig-max="origMaxPrice"
            />
          </b-collapse>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import fa from '@/components/global/icon/fontAwesome'
import services from '@/components/frontoffice/OnlineBooking/home/filters/services'
import category from '@/components/frontoffice/OnlineBooking/home/filters/category'
import price from '@/components/frontoffice/OnlineBooking/home/filters/price'
import travelPolicy from '@/components/frontoffice/OnlineBooking/home/filters/travelPolicy'
import hotelType from '@/components/frontoffice/OnlineBooking/home/filters/hotelType'
import topQualityHotel from '@/components/frontoffice/OnlineBooking/home/filters/topQualityHotel'

export default {
  components: {
    fa,
    services,
    category,
    price,
    travelPolicy,
    hotelType,
    topQualityHotel
  },

  props: {
    minPrice: [Number, String],
    maxPrice: [Number, String],
    origMinPrice: [Number, String],
    origMaxPrice: [Number, String],
    initFilters: Object
  },

  data () {
    return {
      filters: {
        travelPolicy: {
          visible: true,
          props: {
            options: [
              { value: 'fitsTravelPolicy', text: this.$t('online.filters.travelPolicy.options.fitsTravelPolicy') }
            ]
          }
        },
        // topQualityHotel: {
        //   noCollapse: true,
        //   props: {
        //     options: [
        //       { value: 'topQualityHotel' }
        //     ]
        //   }
        // },
        services: {
          props: {
            options: [
              { value: 'parking' },
              { value: 'restaurant' },
              { value: 'internetAccessinRoom' },
              { value: 'breakfast' },
              { value: 'disabled' }
            ]
          },
          visible: false
        },
        category: {
          visible: false
        },
        price: {
          visible: false,
          props: {
            min: this.minPrice,
            max: this.maxPrice
          }
        },
        hotelType: {
          props: {
            options: [
              { value: 'wellness' },
              { value: 'city' },
              { value: 'castle' },
              { value: 'conference' },
              { value: 'design' },
              { value: 'family' },
              { value: 'golf' },
              { value: 'luxury' },
              { value: 'beach' },
              { value: 'hiking' },
              { value: 'resort' },
              { value: 'ski' }
            ]
          },
          visible: false
        }
      },
      selected: {}
    }
  },

  created () {
    this.transOptions()
  },

  mounted () {
    // this.resetAll()
    this.selected = this.initFilters ? this.initFilters : {}
    this.update()
  },

  methods: {
    transOptions () {
      for (let key of Object.keys(this.filters)) {
        if (!this.filters[key].props) continue
        if (!this.filters[key].props.options) continue
        this.filters[key].props.options.forEach(option => {
          option.text = this.$t(`online.filters.${key}.options.${option.value}`)
        })
      }
    },

    update (data) {
      if (data) {
        this.selected[data.name] = data.value

        if (data.name === 'price') {
          this.filters[data.name].props = data.value
        }
      }

      this.$emit('update', this.selected)
    },

    resetAll () {
      for (let ref of Object.values(this.$refs)) {
        // only apply on arrays
        if (ref[0]) ref[0].reset(false)
      }
    },

    collapseChevronClass (visible) {
      return visible ? 'minus rotation-right' : 'plus rotation-left'
    },

    toggleOpenedComponent (type, visibility) {
      this.filters[type].visible = visibility
    },

    slidePan () {
      this.$refs.filtersPan.classList.toggle('slide-left')
    }
  }
}
</script>
